import { Component, OnInit } from '@angular/core';
import { BriTeammateAuthorizationService } from '@davita/bridge-utility-library/authorization';

@Component({
  selector: 'app-user-pill',
  templateUrl: './user-pill.component.html',
  styleUrls: ['./user-pill.component.scss'],
  standalone: false
})
export class UserPillComponent implements OnInit {
  userName: string = '';
  userRole: string = 'Support Staff';
  userInitials: string = '';

  constructor(private authService: BriTeammateAuthorizationService) {}

  ngOnInit(): void {
    // Try user$ first (has full User object with oim_details)
    this.authService.user$.subscribe(user => {
      if (user) {
        // Check oim_details first (for teammate login)
        const oimDetails = (user as any).oim_details;
        if (oimDetails) {
          // Use userLogin as the display name (e.g., "YKENNO")
          const displayName = oimDetails.userLogin || oimDetails.displayName ||
            `${oimDetails.firstName || ''} ${oimDetails.lastName || ''}`.trim();
          if (displayName) {
            this.userName = displayName;
            this.userInitials = this.getInitials(displayName);
            this.userRole = oimDetails.jobFunctionDesc || 'Support Staff';
            return;
          }
        }

        // Fallback to other user properties
        const name = (user as any).name;
        if (name && (name.given || name.family)) {
          const displayName = `${name.given || ''} ${name.family || ''}`.trim();
          this.userName = displayName;
          this.userInitials = this.getInitials(displayName);
          return;
        } else if (user && user.sub !== undefined && user.sub !== null) {
          this.userName = user.sub;
          this.userInitials = this.getInitials(user.sub);
          return;
        }

        // Last resort - use userName or email
        const fallbackName = (user as any).userName || (user as any).email || 'User';
        this.userName = fallbackName;
        this.userInitials = this.getInitials(fallbackName);
      }
    });
  }

  private getInitials(name: string): string {
    if (!name) return 'U';
    const parts = name.split(' ').filter(p => p.length > 0);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  }

  logout(): void {
    this.authService.logout();
  }
}
